import React, {useEffect, memo, useState} from 'react';
import AnnotatorComponent from '../Components/Annotator/AnnotatorComponent';
//import {hasToken} from "../../Utils/Common";

function DatatoolViewPage(props) {
	//hasToken()
	// A re-render is triggered to have updated DOM in order to fix Document.getElementById() access
	const [renderTriggerCounter, setRenderTriggerCounter] = useState('0')
	useEffect(async () => {
		//hasToken()
		setRenderTriggerCounter('1')
	}, [renderTriggerCounter])

	return (
		<>
			<AnnotatorComponent
				lvComponentShow={true}
				annotationComponentShow={true}
				annotatorFooterShow={false}
				jobID={props.location.state.jobID}
				data_length={props.location.state.data_length}
				adviceList={props.location.state.adviceList}
				lvstatus={props.location.state.lvstatus}
                lvList={props.location.state.lvList.data}
                annotationData={props.location.state.annotationData}
				//setAnnotationData={setAnnotationData}
				lvCustomerView={false}
				annotationCustomerView={false}
				suggestComponentShow={true}
				positionCategoryShow={false}
				highlightPossible={true}
				searchComponentShow={true}
				deleteComponentShow={true}
				summaryComponentShow={false}
				saveComponentShow={false}
				publishComponentShow={false}
				editAdviceComponentShow={false}
				ignoreComponentShow={false}
				categoryComponentShow={false}
				createAdviceComponentShow={false}
			/>
		</>
	)
}

export default memo(DatatoolViewPage);